import React from 'react';
import { motion } from 'framer-motion';
export function PricingCTA() {
  const handleCheckout = () => {
    window.location.href = 'https://mitierravenezuela.com/cart/45551999058106:1';
  };
  return <section id="pricing-section" className="py-10 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-[#0a0a0a] to-[#111]" data-id="element-76">
      <div className="max-w-3xl mx-auto text-center" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#0f0f0f] border border-zinc-800 rounded-2xl p-5 sm:p-8 lg:p-12 shadow-2xl relative overflow-hidden" data-id="element-78">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#FFCC00] via-[#00247D] to-[#CF142B]" data-id="element-79"></div>

          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6 font-serif" data-id="element-80">
            Por qué cuesta solo $19.97
          </h2>

          <p className="text-zinc-400 mb-5 sm:mb-8 text-sm sm:text-base lg:text-lg" data-id="element-81">
            Porque este contenido debería estar al alcance del venezolano común.
            Hoy, por menos de lo que cuesta una cena sencilla, te llevas:
          </p>

          <ul className="text-left max-w-sm mx-auto space-y-3 sm:space-y-4 mb-6 sm:mb-10 text-zinc-300 text-sm sm:text-base" data-id="element-82">
            <li className="flex items-center gap-3" data-id="element-83">
              <span className="text-[#FFCC00] font-bold text-lg sm:text-xl" data-id="element-84">
                +
              </span>
              <span data-id="element-85">Un eBook completo</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-86">
              <span className="text-[#00247D] font-bold text-lg sm:text-xl" data-id="element-87">
                +
              </span>
              <span data-id="element-88">El audiolibro narrado</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-89">
              <span className="text-[#CF142B] font-bold text-lg sm:text-xl" data-id="element-90">
                +
              </span>
              <span data-id="element-91">Una obra para conservar y compartir</span>
            </li>
          </ul>

          <div className="mb-5 sm:mb-8" data-id="element-92">
            <span className="text-4xl sm:text-5xl font-bold text-white tracking-tight" data-id="element-93">
              $19.97
            </span>
            <span className="text-zinc-500 ml-2 text-base sm:text-lg" data-id="element-94">USD</span>
          </div>

          <button onClick={handleCheckout} className="w-full sm:w-auto bg-[#CF142B] hover:bg-[#b01124] text-white font-bold py-3 sm:py-4 px-8 sm:px-12 rounded-lg transition-all transform hover:scale-105 shadow-lg shadow-red-900/20 text-base sm:text-lg mb-4 sm:mb-6" data-id="element-95">
            Obtener Acceso Inmediato
          </button>

          <p className="text-zinc-500 text-xs sm:text-sm" data-id="element-96">
            Descarga digital segura e inmediata.
          </p>
        </motion.div>
      </div>
    </section>;
}